
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckSquare, Calendar, Bug, Lightbulb, FileText, Users } from 'lucide-react';

interface Template {
  id: string;
  name: string;
  icon: React.ReactNode;
  title: string;
  description?: string;
  category?: string;
  tags?: string[];
}

const templates: Template[] = [
  {
    id: 'task',
    name: 'Task',
    icon: <CheckSquare className="h-4 w-4" />,
    title: 'New Task',
    description: 'Add task details here...',
    category: 'task',
  },
  {
    id: 'meeting',
    name: 'Meeting',
    icon: <Users className="h-4 w-4" />,
    title: 'Team Meeting',
    description: 'Meeting agenda and notes...',
    category: 'meeting',
  },
  {
    id: 'bug',
    name: 'Bug Report',
    icon: <Bug className="h-4 w-4" />,
    title: 'Bug Fix',
    description: 'Describe the bug and steps to reproduce...',
    category: 'bug',
  },
  {
    id: 'idea',
    name: 'Idea',
    icon: <Lightbulb className="h-4 w-4" />,
    title: 'New Idea',
    description: 'Brainstorming and creative thoughts...',
    category: 'idea',
  },
  {
    id: 'reminder',
    name: 'Reminder',
    icon: <Calendar className="h-4 w-4" />,
    title: 'Reminder',
    description: 'Don\'t forget to...',
    category: 'reminder',
  },
  {
    id: 'note',
    name: 'Note',
    icon: <FileText className="h-4 w-4" />,
    title: 'Quick Note',
    description: 'Important information...',
    category: 'note',
  },
];

interface QuickTemplatesProps {
  onSelectTemplate: (template: Template) => void;
}

export const QuickTemplates = ({ onSelectTemplate }: QuickTemplatesProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Quick Templates</h3>
      <div className="grid grid-cols-2 gap-3">
        {templates.map((template) => (
          <Button
            key={template.id}
            variant="outline"
            className="h-auto p-4 flex flex-col items-center gap-2 hover:bg-primary/5"
            onClick={() => onSelectTemplate(template)}
          >
            <div className="flex items-center gap-2">
              {template.icon}
              <span className="font-medium">{template.name}</span>
            </div>
            {template.category && (
              <Badge variant="secondary" className="text-xs">
                {template.category}
              </Badge>
            )}
          </Button>
        ))}
      </div>
    </div>
  );
};
